<template>
  <div class="nodeBox" :class="{ 'selectedBox': this.selected }">
    <NodeHeader :title="this.data.label" :hook="this.data.hook" :icon="null" />
    <div
      style="
        width: 100%;
        height: 1px;
        margin: 10px 0;
        background-color: #dadada;
      "
    ></div>
    <!-- <p>{{ this.data.text }}</p> -->
    <div v-if="this.data.type == 'crm_input'">
      <!-- <img :src="this.img_src" /> -->

      <Select
        :items="['Table 1', 'Table 2', 'Table 3']"
        :title="'Select table'"
      />
    </div>
    <Handle
      type="source"
      position="right"
      :style="{
        height: '10px',
        width: '10px',
        backgroundColor: 'white',
        border: 'thin solid #dadada',
      }"
    />
  </div>
</template>

<script>
import { Handle } from "@vue-flow/core";
import Select from "../inputs/Select.vue";
import NodeHeader from "./NodeComponents/NodeHeader.vue";

export default {
  name: "InputNode",
  props: {
    selected: Boolean,
    data: Object,
    // title: String,
    // text: String,
  },
  components: {
    Handle,
    Select,
    NodeHeader,
  },
  data() {
    // const flowImgs = import.meta.glob("@/assets/flow_logos/*.svg", { eager: true });

    console.log(this.data);
    console.log(this.selected);
    // console.log("@/assets/flow_logos/" + this.data.product + ".svg");

    return {
      // img_src: new URL(
      //   `@/assets/flow_logos/${this.data.product}.svg`,
      //   import.meta.url
      // ).href,
    };
  },
};
</script>

<style scoped>
.nodeBox {
  border: thin solid #dadada;
  border-radius: 7px;
  padding: 10px;
  background: white;
}
.nodeBox:hover {
  border: thin solid #721cff;
}
.nodeBox:active {
  box-shadow: 0 0 0 3px #ccadff;
}
.selectedBox {
  border: thin solid #721cff;
  box-shadow: 0 0 0 3px #ccadff;
}
</style>
